import { audioContextSlice } from "./slice";

export const { selectAudioContext } = audioContextSlice.selectors;
